// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___epbg","tabsBox":"styles_tabsBox__1ynX0","createButton":"styles_createButton__1ySKJ"};